// JSON-LD for the `profile` surface (`/portfolio/[user_id]` — the
// `/profile` path 307-redirects there).
//
// Schema choice: ProfilePage with a Person `mainEntity`. ProfilePage is
// the recommended Schema.org type for user/creator landing pages and
// powers Google's profile knowledge panels.

import type { ShareSurface } from '@/lib/share/events';

import { resolveCanonicalOrigin } from '../origin';
import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildProfileJsonLd(
  surface: Extract<ShareSurface, { kind: 'profile' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const personName = ctx.name ?? 'Morfi user';
  const personUrl = `${resolveCanonicalOrigin()}/portfolio/${surface.userId}`;
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'ProfilePage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name: personName,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
      mainEntity: {
        '@type': 'Person',
        '@id': `${personUrl}#person`,
        name: personName,
        url: personUrl,
        image: ctx.ogImageUrl,
      },
    },
  ];
}
